import { getUniqueID } from './game.js';
import { choose } from './ui.js';
import { state } from './stores.js';
import { get } from 'svelte/store';
import { otherPlayer } from './parse.js';

export let desiredTraits = [
    'ambassador', 'business', 'cloak', 'creature', 'doctor', 'engineer',
    'scientist', 'spy', 'synthetic', 'telepath',
    'opp_cap', 'opp_cap'
]


export let khanMissions = [
    {
        name: `I've hurt you`,
        goal: 'Goal: Have 6 traits marked.',
        reward: 'Reward: Take the top [[encounter]].',
        vp: 1
    },
    {
        name: `I shall leave you as you left me`,
        goal: 'Goal: Have 9 traits marked.',
        reward: `Reward: Look at the top 2 [[encounter]], take one of them and return the other to the bottom of its deck. Flip your [[captain]] card.`,
        vp: 2
    },
    {
        name: `Marooned for all eternity! Buried alive!`,
        goal: `Goal: Have all 12 traits marked.`,
        reward: `Attack Reward: Force your opponent to recall a [[person]], if able, and log the recalled card.`,
        vp: 3
    },
]



export function loadKhanDash(e){
    let d = {
        deck: 'Khan',
        id: e.id,
        missions: [],
        passives: [],
        research: [0],
        influence: [0],
        military: [0],
        trackScoring: {
            research: 0,
            military: 0,
            influence: 0
        },
        trackMultiplier: {
            research: 0,
            military: 0,
            influence: 0
        }
    };
    let num = 0;
    for(let m of khanMissions){
        
        let newMission = {
            ...m, 
            allText: m.goal + ' '+m.reward,
            id: `${e.id}_missions_${num}`,
            suits: ['mission'],
            uniqueID: getUniqueID(),//`${e.id}_missions_${num}`,
            traits: [],
            values: [],
            ships: [],
            dashMission: true
        }
        num++;
        d.missions.push(newMission);
    }
    return d;
}

function totalOppTraits(p, opp){
    return Array.from(new Set(opp.decks.captain.flatMap(c => c.traits)));
}


function oppTraitInfo(p, opp = false){
    if(!opp) opp = otherPlayer(p);
    let possTraits = [];
    let markedTraits = [];
    let tot = totalOppTraits(p, opp);
    let includeHuman = (tot.length == 2);
    for(let t of tot){
        if(!p.collected_traits.includes(t)){
            if(includeHuman || t != 'human') possTraits.push(t);
        }else if(desiredTraits.includes(t)){
            // One of the desired lists, so want 2 if possible
            if(p.collected_traits.filter(trait => trait == t).length < 2){
                possTraits.push(t)
            }else{
                markedTraits.push(t); // Got it already
            }
        }else{
            // We already have it
            markedTraits.push(t);
        }
        // Otherwise we already have it and only need 1
    }
   // console.log('opp trait info', markedTraits, possTraits)
    return {
        marked: markedTraits,
        possible: markedTraits.length == 2 ? [] : possTraits // If we have both already, can't have more
    };
}

export function collectableTraits(traits, p, opp = false){
    if(!opp) opp = get(state).players.find(o => o.captain != p.captain);
    // p is Kham, opp is opponent
    if(!p.collected_traits) p.collected_traits = [];
    return traits.filter(t => {
        if(p.collected_traits.length >= desiredTraits.length) return false;
        if(t == 'wildcard') return true;
        if(oppTraitInfo(p, opp).possible.includes(t)) return true;
        if(desiredTraits.includes(t) && !p.collected_traits.includes(t)) return true;
        return false;

        /*let oppLeft = desiredTraits.filter(t => t == 'opp_cap').length - p.collected_traits.filter(t => t == 'opp_cap').length;
        let possibleSpaces = desiredTraits.filter(tr => tr == t).length - p.collected_traits.filter(tr => tr == t).length;
        let totalOppTraits = Array.from(new Set(opp.decks.captain.flatMap(c => c.traits)));
        if(oppLeft > 0){
            // Still some captain traits remaining
            
        }
        if((t != 'human' || totalOppTraits.length == 2) && totalOppTraits.includes(t) && oppLeft > 0) possibleSpaces++; // Only ever one extra
        if(possibleSpaces > 0) return true;
        return false;*/
    })
}

export async function markCollected(trait, p, opp = false){
    if(!opp) opp = get(state).players.find(o => o.captain != p.captain);
    if(collectableTraits([trait], p, opp).length == 0) throw 'Trait already collected'; // ?
    if(trait == 'wildcard'){
       // let availableCapTraits = possibleOppTraits(p, opp); //collectableTraits(opp.decks.captain.flatMap(c => c.traits), p, opp);
        //let toChoose = desiredTraits.filter(t => t != 'opp_cap');
        //if(availableCapTraits.length > 0) toChoose = [...toChoose, ...availableCapTraits]; // !! TODO just added this in case?
        let traits = [...collectableTraits(desiredTraits.filter(t => t != 'opp_cap'), p), ...oppTraitInfo(p).possible];
        trait = await choose(`Which trait do you want [[wildcard]] to be marked as?`, traits.sort((a,b) => a.localeCompare(b)).map(t => `[[${t}]]`));
        if(!trait || trait == 'cancelled') throw 'cancelled';
        trait = traits.find(t => trait == `[[${t}]]`);
    }
    p.collected_traits = [...p.collected_traits, trait]; 
    return true;
}

export function getTraitTicks(p){
    // Returns a list of traits with ticks
    let oppNames = [
        `a trait matching your opponent's [[captain]] (excluding [[human]], if possible)`,
        `a different trait matching your opponent's [[captain]] (excluding [[human]], if possible)`
    ];
    let oppCount = 0;
    let ret = desiredTraits.map(t => {
        if(t != 'opp_cap'){
            return {
                trait: t,
                text: `[[${t}]]`,
                ticked: false
            }
        }else{
            let index = Math.min(oppCount, oppNames.length - 1)
            oppCount++;
            return {
                trait: oppNames[index],
                text: `${oppNames[index]}`,
                special: 'opp_cap',
                ticked: false
            }
        }
    })
    let collected  = p.collected_traits || [];
    
    for(let t of collected){
        if(desiredTraits.includes(t)){
            let f = ret.find(r => r.trait == t);
            f.ticked = true;
        }/*else{
            // Must be opponent captain one
            let poss = ret.find(r => r.special == 'opp_cap' && !r.ticked);
            if(poss) poss.ticked = true;
        }*/
    }

    for(let t of oppTraitInfo(p).marked){
        // Just tick one by one
        let f = ret.find(r => r.special == 'opp_cap' && !r.ticked);
        if(f){
            f.ticked = true;
            f.text = `[[${t}]]: ${f.text}`;
        }
    }

    return ret;
}

export function botMarkedScore(p){
    if(!p.collected_traits) return 0;
    return p.collected_traits.length * 3;
}